import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { fetchStore, updateStore } from 'utils/api/storeApi'
import { PAGE_NOT_FOUND, PAGE_STORE_MGMT } from 'utils/constants'
import { Button, Spinner } from 'components/common'
import { StoreDetailsForm } from 'components/storeManagement'
import BackButton from 'components/backButton'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { updateStoreSchema } from 'utils/schema/storeSchema'
import { StoreFormData } from 'components/storeManagement/utils'

export type UpdateStoreFormData = Omit<StoreFormData, 'storeId'> & {
  storeId?: string
}

const UpdateStorePage = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean>(true)
  const [store, setStore] = useState<any>({})

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<UpdateStoreFormData>({
    resolver: yupResolver(updateStoreSchema),
  })

  const getStoreDetails = async (id: string) => {
    try {
      const { data } = await fetchStore(id)
      data.storeId = data._id
      setStore(data)
      delete data._id
      reset(data)
    } catch (error) {
      setStore({})
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      getStoreDetails(id)
    }
  }, [])

  if (loading) {
    return <Spinner />
  }

  const handleUpdateStore = async (data: UpdateStoreFormData) => {
    if (!id) return

    const toastStore = toast.loading('Updating Store...', {
      duration: Infinity,
    })

    try {
      delete data.storeId

      await updateStore(id, data)

      toast.success('Store updated successfully!', {
        id: toastStore,
        duration: 3000,
      })

      reset()
      navigate(PAGE_STORE_MGMT.path)
    } catch (error) {
      toast.error('Failed to update store!', {
        id: toastStore,
        duration: 3000,
      })
    }
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit(handleUpdateStore)}>
        <StoreDetailsForm
          setValue={setValue}
          register={register}
          errors={errors}
          store={store}
          isOptional
        />

        <Button buttonText="Update Store" className="mt-7 w-44" />
      </form>
    </>
  )
}

export default UpdateStorePage
